export const UPDATE_EVENT_DETAILS = 'UPDATE_EVENT_DETAILS';
export const RESET_EVENT_DETAILS = 'RESET_EVENT_DETAILS';
export const UPDATE_EVENT_STYLE_PREVIEW = 'UPDATE_EVENT_STYLE_PREVIEW';
export const UPDATE_PAGE_DETAIL_PREVIEW = 'UPDATE_PAGE_DETAIL_PREVIEW';
